export default __webpack_public_path__ + "static/media/Icon_Card_02.b0ccbf9f.png";